
export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-[#FF6B6B] to-[#EE5A6F] text-white py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
            2026年最新版
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            即日発行できる<br className="md:hidden" />クレジットカード<br className="md:hidden" />おすすめ5選
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto mb-8">
            今すぐ使いたい方必見！最短10秒でカード番号が発行され、すぐにネットショッピングやスマホ決済で利用できるクレジットカードを徹底解説します。
          </p>

          {/* ファーストビュー即決CTA */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 max-w-xl mx-auto">
            <div className="flex items-center justify-center gap-2 mb-3">
              <i className="ri-trophy-fill text-amber-300 text-xl"></i>
              <span className="font-bold text-lg">迷ったらコレ！No.1おすすめ</span>
            </div>
            <div className="bg-white rounded-xl p-4 mb-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-gray-900 font-bold text-lg">三井住友カード（NL）</span>
                <span className="bg-teal-100 text-teal-700 text-xs font-bold px-2 py-1 rounded-full">最短10秒発行</span>
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                <span className="flex items-center gap-1">
                  <i className="ri-price-tag-3-line text-teal-600"></i>
                  年会費永年無料
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-percent-line text-teal-600"></i>
                  最大7%還元
                </span>
              </div>
              <a
                href="/mitsui"
                className="block w-full bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-3 rounded-lg font-bold text-center hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-line mr-2"></i>
                詳細を見る
              </a>
            </div>
            <p className="text-white/80 text-sm">
              ※審査状況により発行時間は異なります
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
